import { FourPicturesOneSolutionQuestionDownloadDto } from 'collaboration-service';
import * as React from 'react';
import EditLanguageStrings from '../Editors/EditLanguageStrings';
import EditMedia from '../Editors/EditMedia';
import EditPartContainer, { EditPartContainerType } from '../EditPartContainer';
import EditPartLabelAndEditor from '../EditPartLabelAndEditor';
import GenPropQuestion from './GenPropQuestion';
import PrePostFixQuestion from './PrePostFixQuestion';

interface PostEditQuizFourPicturesOneSolutionQuestionProps {
    epc: EditPartContainerType;
    registerClosed?: boolean;
}

const PostEditQuizFourPicturesOneSolutionQuestion = (p: PostEditQuizFourPicturesOneSolutionQuestionProps) => {
    const { epc, registerClosed } = p;
    return (
        <>
            <EditPartContainer icon="image" title="medias" {...epc} registerClosed={false}>
                <EditPartLabelAndEditor>
                    {[
                        { label: { icon: "image", content: "media" }, editor: <EditMedia<FourPicturesOneSolutionQuestionDownloadDto> getter={x => x.media} imgAspect={16 / 9} width='50%' disableLabel /> },
                        { label: { icon: "image", content: "media1" }, editor: <EditMedia<FourPicturesOneSolutionQuestionDownloadDto> getter={x => x.media1} imgAspect={16 / 9} width='50%' disableLabel /> },
                        { label: { icon: "image", content: "media2" }, editor: <EditMedia<FourPicturesOneSolutionQuestionDownloadDto> getter={x => x.media2} imgAspect={16 / 9} width='50%' disableLabel /> },
                        { label: { icon: "image", content: "media3" }, editor: <EditMedia<FourPicturesOneSolutionQuestionDownloadDto> getter={x => x.media3} imgAspect={16 / 9} width='50%' disableLabel /> },
                    ]}
                </EditPartLabelAndEditor>
            </EditPartContainer>
            <GenPropQuestion epc={epc} registerClosed={registerClosed} />
            <EditPartContainer icon="clipboard" title="correct answers" {...epc} registerClosed={false}>
                <EditPartLabelAndEditor>
                    {[
                        { label: { icon: "asking", content: "correct answers" }, editor: <EditLanguageStrings<FourPicturesOneSolutionQuestionDownloadDto> getter={x => x.correctAnswers!} /> },
                        // { label: { icon: "subtitle", content: "suggestions" }, editor: <EditLanguageStrings<FourPicturesOneSolutionQuestionDownloadDto> getter={x => x.suggestions} /> },
                    ]}
                </EditPartLabelAndEditor>
            </EditPartContainer>
            <PrePostFixQuestion epc={epc} registerClosed={registerClosed} />
        </>
    );
}
export default PostEditQuizFourPicturesOneSolutionQuestion;